import ModalsConfig from 'components/modal/ModalConfig'
import AlertModal from 'components/modal/common/AlertModal'
import ConfirmModal from 'components/modal/common/ConfirmModal'

import PreOrderList from 'pages/head/preorder/PreOrderList'
import PreOrderReg from 'pages/head/preorder/PreOrderReg'
import Carte from 'pages/menucrte/carte/Carte'

import Ingredients from 'pages/popup/Ingredients'
import RelatedMenu from 'pages/popup/RelatedMenu'
import SteSrch from 'pages/popup/SteSrch'

import Address from 'pages/popup/AddressSearch'
import Cmow from 'pages/popup/Cmow'
import CmowEmp from 'pages/popup/CmowEmp'
import Goods from 'pages/popup/GoodsSearch'
import MenuRecip from 'pages/popup/MenuRecip'
import Notification from 'pages/popup/Notification'
import CustsfdgPsntReg from 'pages/shop/custsfdg/popup/CustSfdgPsntReg'

import Frame from 'pages/popup/Frame'
import ImageRegist from 'pages/popup/ImageRegist'
import SearchFilter from 'pages/search/SearchFilter'

import Popup from 'components/Popup'
import OpenSourceLicense from 'pages/popup/OpenSourceLicense'
import ImageViewer from './../pages/popup/ImageViewer'

/**
 * @description 공통 Modal용 Hook
 * @author 이종술
 * @since 2023-02-05
 * 업무 : Hook > 공통 > Modal Hook
 */

//Modal 사용 Hook 생성
export default function useModal() {
  const { open, close, closeAll } = ModalsConfig()

  const openModal = (
    Component,
    props = {
      title: '알림',
      okButtonName: '확인',
      cancelButtonName: '닫기',
      dimClickClose: true, //Dim 클릭시 Close처리 true/false
    },
    ok,
    cancel,
  ) => {
    if (!props.title) {
      props.title = '알림'
    }
    if (!props.okButtonName) {
      props.okButtonName = '확인'
    }
    if (!props.cancelButtonName) {
      props.cancelButtonName = '닫기'
    }

    // Modal Ok Button Event Handler
    const okButtonEvent = (result) => {
      // Ok Button 후처리 함수 있을경우
      if (ok) {
        ok(result)
      } else {
        closeModal()
      }
    }

    // Modal Close Event Handler
    const cancelButtonEvent = () => {
      // Cancel Button 후처리 함수 있을경우
      if (cancel) {
        cancel()
      } else {
        closeModal()
      }
    }
    //Recoil State 추가
    open(Component, props, okButtonEvent, cancelButtonEvent)
    return
  }

  // Modal Close
  const closeModal = () => {
    //Recoil State 삭제
    close()
  }

  // Modal Close
  const closeModalAll = () => {
    //Recoil State 삭제
    closeAll()
  }

  // Alert Modal Open(By Props)
  const openAlertModal = (props, ok) => {
    const alertProps = {
      ...props,
      modalName: 'AlertModal',
    }
    openModal(AlertModal, alertProps, ok)
  }

  // Confirm Modal Open(By Props)
  const openConfirmModal = (props, ok, cancel) => {
    const confirmProps = {
      ...props,
      modalName: 'ConfirmModal',
    }
    openModal(ConfirmModal, confirmProps, ok, cancel)
  }

  // Confirm Modal Open(By 메시지)
  const alertModal = (contents, ok) => {
    const props = {
      title: '알림',
      contents: contents,
      okButtonName: '확인',
      dimClickClose: true,
    }

    openAlertModal(props, ok)
  }

  // Confirm Modal Open(By 메시지)
  const confirmModal = (contents, ok, cancel) => {
    const props = {
      title: '알림',
      contents: contents,
      okButtonName: '확인',
      cancelButtonName: '취소',
      dimClickClose: false,
    }

    openConfirmModal(props, ok, cancel)
  }

  //메뉴&레시피 팝업
  const openMenuRecip = (info, onClose = () => {}) => {
    const props = {}
    const MenuRecipPopup = () => {
      return (
        <Popup
          title={'메뉴&레시피'}
          isShare={true}
          shareClick={() => openCmowEmp({ ...info, dvsn: 'M' })}
          onClose={onClose}
        >
          <MenuRecip info={info} />
        </Popup>
      )
    }
    openModal(MenuRecipPopup, props)
  }

  // 식단팝업
  const openCarte = (info) => {
    const props = {}
    const CartePopup = () => {
      return (
        <>
          <Popup title={'식단'} isShare={true} shareClick={() => openCmowEmp({ ...info, dvsn: 'C' })}>
            <Carte info={info} onClose={() => closeModal()} />
          </Popup>
        </>
      )
    }
    openModal(CartePopup, props)
  }

  // 식재팝업
  const openIngredients = (info) => {
    const props = {}
    const IngredientsPopup = () => {
      return (
        <>
          {/* <Popup title={'식재'} isShare={true} shareClick={() => openCmowEmp({...info, dvsn:'F'})}> */}
          <Ingredients info={info} />
          {/* </Popup> */}
        </>
      )
    }
    openModal(IngredientsPopup, props)
  }

  // 메뉴검색팝업
  // 메뉴타입(임시신메뉴: 30, 사이트: 20, 표준: 10)
  const openRelateMenu = (keywoard, menuType = '', ok) => {
    const props = {}
    const RelateMenuPopup = () => {
      return (
        <Popup title={'메뉴검색'}>
          <RelatedMenu keyword={keywoard} menuType={menuType} ok={ok} />
        </Popup>
      )
    }
    openModal(RelateMenuPopup, props)
  }

  // 사이트 검색
  const openSteSrch = (keywoard, ok) => {
    const props = {}
    const RelateMenuPopup = () => {
      return (
        <Popup title={'사이트검색'}>
          <SteSrch keyword={keywoard} ok={ok} />
        </Popup>
      )
    }
    openModal(RelateMenuPopup, props)
  }

  // 사전상품 신청
  const openPreOrderReg = (ntcAtclId) => {
    const props = {}
    const RelateMenuPopup = () => {
      return (
        <Popup title={'사전상품 신청'}>
          <PreOrderReg ntcAtclId={ntcAtclId} />
        </Popup>
      )
    }
    openModal(RelateMenuPopup, props)
  }
  // 사전상품 신청현황
  const openPreOrderList = (ntcAtclId) => {
    const props = {}
    const RelateMenuPopup = () => {
      return (
        <Popup title={'사전상품신청현황'}>
          <PreOrderList ntcAtclId={ntcAtclId} />
        </Popup>
      )
    }
    openModal(RelateMenuPopup, props)
  }

  //공유하기 받을사람
  const openCmowEmp = (info) => {
    const props = {}
    const CmowEmpPopup = () => {
      return (
        <Popup title={'공유하기'}>
          <CmowEmp info={info} />
        </Popup>
      )
    }
    openModal(CmowEmpPopup, props)
  }

  //공유하기 팝업
  const openCmow = (info, emp, ok) => {
    const props = {}
    const CmowPopup = () => {
      return (
        <Popup title={'공유하기'}>
          <Cmow info={info} emp={emp} ok={ok} />
        </Popup>
      )
    }
    openModal(CmowPopup, props)
  }

  //알림 팝업
  const openNotifaction = () => {
    const props = {}
    const NotificationPopup = () => {
      return (
        <Popup title={'알림'}>
          <Notification />
        </Popup>
      )
    }
    openModal(NotificationPopup, props)
  }

  //고객만족도 직접입력 팝업
  const openCustSfdgPsntReg = (date, func) => {
    const props = {}
    const CustSfdgPsntRegPopup = () => {
      return (
        <Popup title={'고객만족도 직접입력'}>
          <CustsfdgPsntReg func={func} date={date} />
        </Popup>
      )
    }
    openModal(CustSfdgPsntRegPopup, props)
  }

  //검색필터 팝업
  const openSearchFilter = (data, func) => {
    const props = {}
    const SearchFilterPopup = () => {
      return (
        <Popup title={'상세검색'}>
          <SearchFilter data={data} func={func} />
        </Popup>
      )
    }
    openModal(SearchFilterPopup, props)
  }

  //주소검색 팝업
  const openSearchAddress = (data, func) => {
    const props = {}
    const SearchAddress = () => {
      return (
        <Popup title={'주소검색'}>
          <Address data={data} ok={func} />
        </Popup>
      )
    }
    openModal(SearchAddress, props)
  }

  //상품검색 팝업
  const openSearchGoods = (data, func) => {
    const props = {}
    const SearchGoods = () => {
      return (
        <Popup title={'상품검색'}>
          <Goods data={data} ok={func} />
        </Popup>
      )
    }
    openModal(SearchGoods, props)
  }

  //이미지등록 팝업
  const openImageRegist = (data) => {
    const props = {}
    const ImageRegistPopup = () => {
      return (
        <Popup title={'이미지등록'}>
          <ImageRegist data={data} />
        </Popup>
      )
    }
    openModal(ImageRegistPopup, props)
  }

  //이미지뷰어 팝업
  const openImageViewer = (imgSrc) => {
    const props = {}
    const ImageRegistPopup = () => {
      return (
        <Popup title={'이미지'}>
          <ImageViewer imgSrc={imgSrc} />
        </Popup>
      )
    }
    openModal(ImageRegistPopup, props)
  }

  //페이지 팝업용
  const openFramePopup = (url, title) => {
    const props = {}
    const FramePopup = () => {
      return <Frame url={url} title={title} />
    }
    openModal(FramePopup, props)
  }

  //라이센스 팝업용
  const openLicense = () => {
    const props = {}
    const OpenSourceLicensePopup = () => {
      return (
        <Popup title={'오픈소스 라이센스'}>
          <OpenSourceLicense />
        </Popup>
      )
    }
    openModal(OpenSourceLicensePopup, props)
  }

  return {
    openModal,
    openAlertModal,
    openConfirmModal,
    alertModal,
    confirmModal,
    closeModal,
    closeModalAll,
    openCarte,
    openIngredients,
    openSteSrch,
    openRelateMenu,
    openPreOrderReg,
    openPreOrderList,
    openMenuRecip,
    openCmowEmp,
    openCmow,
    openNotifaction,
    openCustSfdgPsntReg,
    openSearchFilter,
    openSearchAddress,
    openSearchGoods,
    openImageRegist,
    openImageViewer,
    openFramePopup,
    openLicense,
  }
}
